<script setup lang="ts">
import type { CmsElementHeadlineTextButtonVideo } from "@/composables/useCustom";

const props = defineProps<{
  content: CmsElementHeadlineTextButtonVideo;
}>();

const { headlineText, mainText, button, coverImage, videoLink, videoUpload } =
  props.content?.data;

const getYoutubeThumbnailUrl = () => {
  if (isYoutubeVideo.value) {
    console.log(videoLink.url);
    const regex =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = videoLink.url.match(regex);
    const videoId = match ? match[1] : null;
    return videoId ? `https://img.youtube.com/vi/${videoId}/0.jpg` : null;
  }
  return null;
};

const isVideoUploaded = computed(() => !!videoUpload?.media?.url);

const getVideo = computed(() =>
  isVideoUploaded.value ? videoUpload?.media : videoLink
);

const isYoutubeVideo = computed(
  () => videoLink?.url && videoLink?.url.includes("youtube.com")
);

const showElement = computed(() => {
  return getVideo.value?.url && coverImage?.media?.url;
});
</script>
<template>
  <div v-if="showElement" class="cust-slide-inspire px-4">
    <div class="container mx-auto pt-12 pb-16 sm:py-24 relative">
      <div class="slider inspire-you-slider">
        <div class="inner-wrap">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-0">
            <div
              class="flex flex-col justify-center left w-full md:w-[350px] lg:w-[488px] mb-6 md:mb-0"
            >
              <div class="description">
                <h5
                  v-if="headlineText"
                  class="font-bold leading-normal text-lg md:text-2xl mb-4"
                >
                  {{ headlineText }}
                </h5>
                <div
                  v-if="mainText"
                  class="text-sm font-normal text-dark-bg leading-relaxed mb-8"
                  v-html="mainText"
                ></div>
                <SharedButton
                  v-if="button"
                  :button="button"
                  class="btn-default btn-black-bg btn-default px-11"
                >
                </SharedButton>
              </div>
            </div>

            <div class="right py-0 lg:pl-8 xl:pl-2">
              <div class="wrap-img">
                <figure
                  v-if="coverImage?.media?.url || getYoutubeThumbnailUrl()"
                  class="relative hover:cursor-pointer group"
                >
                  <NuxtImg
                    v-if="coverImage?.media?.url"
                    ref="imageElement"
                    loading="lazy"
                    format="webp"
                    :height="coverImage?.media?.metaData?.height"
                    :width="coverImage?.media?.metaData?.width"
                    :src="coverImage?.media?.url"
                    :alt="headlineText || ''"
                    class="w-full h-auto rounded-lg group-hover:opacity-90"
                    data-testid="inspire-img"
                  />

                  <NuxtImg
                    v-else-if="getYoutubeThumbnailUrl()"
                    ref="imageElement"
                    loading="lazy"
                    format="webp"
                    :src="getYoutubeThumbnailUrl()!"
                    :alt="headlineText || ''"
                    class="w-full h-auto rounded-lg group-hover:opacity-90"
                    data-testid="inspire-img"
                  />

                  <SharedFancybox :options="{}">
                    <a
                      data-fancybox=""
                      :href="getVideo?.url"
                      class="w-full h-full flex justify-center items-center absolute top-0 left-0 z-10 group"
                      :class="{
                        'pointer-events-none': !getVideo?.url,
                      }"
                    >
                      <div
                        v-if="getVideo?.url"
                        class="absolute top-1/2 left-1/2 bg-red-bg h-12 w-12 transition-all duration-300 group-hover:scale-120 text-white flex items-center justify-center rounded-full"
                      >
                        <i class="fa fa-play"></i>
                      </div>
                      <span v-else class="absolute text-2xl ml-2">
                        <i
                          class="fa-solid fa-spinner animate-spin text-white"
                        ></i>
                      </span>
                    </a>
                  </SharedFancybox>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
